export const removeFalsy = (obj) => {
  let newObj = {};
  Object.keys(obj).forEach((props) => {
    if (obj[props] || obj[props] === "0" || obj[props] === 0 || obj[props] !== "") {
      newObj[props] = obj[props];
    }
  });

  return newObj;
};

export const formatFormData = (obj) => {
  let newObj = {};
  Object.keys(obj).forEach((props) => {
    if (obj[props] === undefined || obj[props] === "") {
      newObj[props] = null;
    } else {
      newObj[props] = obj[props];
    }
  });

  return newObj;
};
